import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const requiredItems = [{
  item: 'A handgun in good working order',
  details: ['Recommended: double action revolvers or semi-automatics', 'Recommended minimum caliber is .38 special or 9mm', 'NO magnum ammo allowed (i.e. .357 mag, .44mag)']
}, {
  item: '(2) speed loaders for revolvers or minimum (2) magazines for semi-autos'
}, {
  item: 'Ammo (minimum 100 rounds on day one and 100 rounds on day two)'
}, {
  item: 'Ear & Eye Protection'
}, {
  item: 'Concealment garment (vest, jacket, sportcoat, etc.)'
}, {
  item: 'Strong side, outside the waistband holster or holster purse',
  details: ['Holster must securely hold the gun', 'Waistband holsters must allow for safe & easy one-handed reholstering', 'Waistband holsters must be secured by means of a belt', 'NO tactical holsters allowed', 'NO competition holsters allowed']
}, {
  item: 'Note pad & pen/pencil'
}, {
  item: 'Ball cap'
}];
const optionalItems = ['Spare magazine or speed loader pouch', 'Lunch', 'Water/Pop/Snacks'];
export function WhatToBring() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2438">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2439">
        <div className="mb-12" data-id="element-2440">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2441">
            What to Bring to Class
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2442">
            <h3 className="text-lg font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2443">
              Required Items
            </h3>
            <div className="space-y-4 mb-8" data-id="element-2444">
              {requiredItems.map((req, index) => <div key={index} data-id="element-2445">
                  <div className="flex items-start gap-3" data-id="element-2446">
                    <CheckCircleIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                  color: '#1e3d2f'
                }} data-id="element-2447" />
                    <span className="text-base text-gray-800 font-medium" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2448">
                      {req.item}
                    </span>
                  </div>
                  {req.details && <ul className="ml-9 mt-2 space-y-1" data-id="element-2449">
                      {req.details.map((detail, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-2450">
                          <span className="text-gray-400 mt-0.5" data-id="element-2451">–</span>
                          <span style={{
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2452">
                            {detail}
                          </span>
                        </li>)}
                    </ul>}
                </div>)}
            </div>

            <h3 className="text-lg font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2453">
              Optional Items
            </h3>
            <div className="space-y-2" data-id="element-2454">
              {optionalItems.map(item => <div key={item} className="flex items-start gap-3" data-id="element-2455">
                  <div className="w-2 h-2 rounded-full flex-shrink-0 mt-2" style={{
                backgroundColor: '#c8a84b'
              }} data-id="element-2456" />
                  <span className="text-base text-gray-600" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2457">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}